var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 3.3335H3.33329C2.41663 3.3335 1.67496 4.0835 1.67496 5.00016L1.66663 15.0002C1.66663 15.9168 2.41663 16.6668 3.33329 16.6668H16.6666C17.5833 16.6668 18.3333 15.9168 18.3333 15.0002V5.00016C18.3333 4.0835 17.5833 3.3335 16.6666 3.3335ZM16.3333 6.87516L10.4416 10.5585C10.175 10.7252 9.82496 10.7252 9.55829 10.5585L3.66663 6.87516C3.45829 6.74183 3.33329 6.51683 3.33329 6.27516C3.33329 5.71683 3.94163 5.3835 4.41663 5.67516L9.99996 9.16683L15.5833 5.67516C16.0583 5.3835 16.6666 5.71683 16.6666 6.27516C16.6666 6.51683 16.5416 6.74183 16.3333 6.87516Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f53fb204d0708fea03cdd74c649972a1.svg";
export { ForwardRef as ReactComponent };